import { injectIntl, useIntl } from 'react-intl';

const Footer = ({ isWide }) => (
  <footer className='footer' id='footer'>
    <div className={`${isWide ? 'section-wide' : 'section'}`}>
      <span
        className='copyright footer-element'
        dangerouslySetInnerHTML={{
          __html: useIntl().formatMessage(
            {
              id: 'Copyright &copy; 2002-{YEAR} PragmaGO. All rights reserved.',
            },
            {
              YEAR: new Date().getFullYear(),
            }
          ),
        }}
      />
    </div>
  </footer>
);

export default injectIntl(Footer);
